export default __webpack_public_path__ + "static/ProductSans-Medium-c1544ac0ea1490578305ce7c923e7c0c.woff2";